import React from "react";
import GenericCrudPage from "./GenericCrudPage";
import { Badge } from "@/components/ui/badge";
import { Mail, Send, FileText, Archive } from "lucide-react";

const STATUS = ["Baru","Diproses","Selesai","Diarsipkan"];
const KATEGORI = ["Regulasi","Operasional","Training","Perlengkapan","SDM","Lainnya"];

const statusBadge = (s) => {
  const m = { Baru:"bg-sky-100 text-sky-700", Diproses:"bg-amber-100 text-amber-700", Selesai:"bg-emerald-100 text-emerald-700", Diarsipkan:"bg-slate-200 text-slate-700" };
  return <Badge className={`${m[s] || m.Baru} hover:${m[s]}`}>{s}</Badge>;
};

const masukFields = (searchable=true) => ([
  { key: "nomor_surat", label: "Nomor Surat", mono: true, colSpan: 2 },
  { key: "tanggal_surat", label: "Tgl Surat", type: "date" },
  { key: "tanggal_diterima", label: "Tgl Diterima", type: "date" },
  { key: "pengirim", label: "Pengirim", colSpan: 2 },
  { key: "perihal", label: "Perihal", colSpan: 2 },
  { key: "kategori", label: "Kategori", type: "select", options: KATEGORI },
  { key: "pic", label: "PIC" },
  { key: "status", label: "Status", type: "select", options: STATUS, badge: statusBadge },
  { key: "attachment", label: "Lampiran", type: "file", colSpan: 2 },
  { key: "catatan", label: "Catatan", type: "textarea", colSpan: 2, hideInTable: true },
]);

const keluarFields = () => ([
  { key: "nomor_surat", label: "Nomor Surat", mono: true, colSpan: 2 },
  { key: "tanggal_surat", label: "Tgl Surat", type: "date" },
  { key: "tujuan", label: "Tujuan/Penerima", colSpan: 2 },
  { key: "perihal", label: "Perihal", colSpan: 2 },
  { key: "kategori", label: "Kategori", type: "select", options: KATEGORI },
  { key: "pic", label: "PIC" },
  { key: "status", label: "Status", type: "select", options: STATUS, badge: statusBadge },
  { key: "attachment", label: "Lampiran", type: "file", colSpan: 2 },
  { key: "catatan", label: "Catatan", type: "textarea", colSpan: 2, hideInTable: true },
]);

const summary = [
  { label: "Total", icon: Mail, tone: "bg-slate-100 text-slate-700", compute: (d)=>d.length },
  { label: "Baru", icon: FileText, tone: "bg-sky-100 text-sky-700", compute: (d)=>d.filter(x=>x.status==="Baru").length },
  { label: "Diproses", icon: Send, tone: "bg-amber-100 text-amber-700", compute: (d)=>d.filter(x=>x.status==="Diproses").length },
  { label: "Selesai/Arsip", icon: Archive, tone: "bg-emerald-100 text-emerald-700", compute: (d)=>d.filter(x=>x.status==="Selesai" || x.status==="Diarsipkan").length },
];

const searchKeys = ["nomor_surat","pengirim","tujuan","perihal","pic"];
const filterFields = [{ key: "status", label: "Status", options: STATUS }, { key: "kategori", label: "Kategori", options: KATEGORI }];

export function SuratPilotMasukPage() {
  return <GenericCrudPage resource="surat/pilot-masuk" title="Surat Masuk · Pilot Management" subtitle="Manajemen Surat"
    moduleKey="surat_pilot" testidPrefix="surat-pilot-masuk"
    fields={masukFields()} defaultItem={{ nomor_surat:"", tanggal_surat:"", tanggal_diterima:"", pengirim:"", perihal:"", kategori: KATEGORI[0], pic:"", status:"Baru", catatan:"", attachment:null }}
    searchKeys={searchKeys} filterFields={filterFields} summaryCards={summary}/>;
}
export function SuratPilotKeluarPage() {
  return <GenericCrudPage resource="surat/pilot-keluar" title="Surat Keluar · Pilot Management" subtitle="Manajemen Surat"
    moduleKey="surat_pilot" testidPrefix="surat-pilot-keluar"
    fields={keluarFields()} defaultItem={{ nomor_surat:"", tanggal_surat:"", tujuan:"", perihal:"", kategori: KATEGORI[0], pic:"", status:"Baru", catatan:"", attachment:null }}
    searchKeys={searchKeys} filterFields={filterFields} summaryCards={summary}/>;
}
export function SuratFAMasukPage() {
  return <GenericCrudPage resource="surat/fa-masuk" title="Surat Masuk · FA Management" subtitle="Manajemen Surat"
    moduleKey="surat_fa" testidPrefix="surat-fa-masuk"
    fields={masukFields()} defaultItem={{ nomor_surat:"", tanggal_surat:"", tanggal_diterima:"", pengirim:"", perihal:"", kategori: KATEGORI[0], pic:"", status:"Baru", catatan:"", attachment:null }}
    searchKeys={searchKeys} filterFields={filterFields} summaryCards={summary}/>;
}
export function SuratFAKeluarPage() {
  return <GenericCrudPage resource="surat/fa-keluar" title="Surat Keluar · FA Management" subtitle="Manajemen Surat"
    moduleKey="surat_fa" testidPrefix="surat-fa-keluar"
    fields={keluarFields()} defaultItem={{ nomor_surat:"", tanggal_surat:"", tujuan:"", perihal:"", kategori: KATEGORI[0], pic:"", status:"Baru", catatan:"", attachment:null }}
    searchKeys={searchKeys} filterFields={filterFields} summaryCards={summary}/>;
}
